import { gql } from '@apollo/client'

export default gql`
  fragment ProductSpecificationItemFragment on ProductSpecificationItem {
    ... on ProductSpecificationItemReference {
      __typename
      name
      text
      references {
        ... on Page {
          id
          title
          type
          url
        }
      }
    }
    ... on ProductSpecificationItemText {
      __typename
      name
      text
    }
    ... on ProductSpecificationItemUnit {
      __typename
      name
      unit {
        category
        type
      }
      format
    }
  }
  fragment ProductSpecificationFragment on Product {
    specifications {
      groups {
        name
        items {
          ...ProductSpecificationItemFragment
          ... on ProductSpecificationItemMultiple {
            name
            items {
              ...ProductSpecificationItemFragment
            }
          }
        }
      }
    }
  }
`
